import React, {Component} from 'react';
import styles from './AwairScoreSection.scss';
import classNames from 'classnames/bind';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import ScrollMagic from 'ScrollMagic';
import $ from 'jquery';
import {ScoreCircle} from '../../molecules';

const cx = classNames.bind(styles);

class AwairScoreStore {
  @observable poorRun = false;
  @observable fairRun = false;
  @observable goodRun = false;
  @observable unhidden = false;

  @action startPoorRun = () => this.poorRun = true;
  @action startFairRun = () => this.fairRun = true;
  @action startGoodRun = () => this.goodRun = true;
  @action stopRuns = () => {
    this.poorRun = false;
    this.fairRun = false;
    this.goodRun = false;
  };
  @action activeUnhidden = () => this.unhidden = true;
  @action unactiveUnhidden = () => this.unhidden = false;
}

const awairScoreStore = new AwairScoreStore();

@observer
class AwairScoreSection extends Component {
  awairScoreRef;

  handleSceneAnimation = () => {
    const {awairScoreRef} = this;
    const {
      startPoorRun,
      startFairRun,
      startGoodRun,
      stopRuns,
      activeUnhidden,
      unactiveUnhidden
    } = awairScoreStore;

    let scoreAnimInProgress = 0;
    let scoreAnimResetRequested = 0;

    const startScoreAnim = () => {
      if (scoreAnimInProgress === 0) {
        // start the CSS animation
        scoreAnimInProgress = 1;

        // 00 to 55
        startPoorRun();
        $({countNum: $('#poorScoreValue').text()}).animate({countNum: 55}, {
          duration: 2000,
          step: function () {
            let poorScoreCache = Math.floor(this.countNum);
            $('#poorScoreValue').text(poorScoreCache);
          },
          complete: function () {
            $('#poorScoreValue').text(this.countNum);
          }
        });

        // 55 to 74
        // start 200ms before previous is done
        setTimeout(() => {
          startFairRun();
          $({countNum: $('#fairScoreValue').text()}).animate({countNum: 74}, {
            duration: 2000,
            step: function () {
              let fairScoreCache = Math.floor(this.countNum);
              if (fairScoreCache > 60) {
                $('#fairScoreLabel').text('普通');
              }
              $('#fairScoreValue').text(fairScoreCache);
            },
            complete: function () {
              $('#fairScoreValue').text(this.countNum);
            }
          });
        }, 1800);

        // 74 to 90
        // start 200ms before previous is done
        setTimeout(function() {
          startGoodRun();
          $({countNum: $('#goodScoreValue').text()}).animate({countNum: 90}, {
            duration: 2000,
            step: function() {
              let goodScoreCache = Math.floor(this.countNum);
              if (goodScoreCache > 85) {
                $('#goodScoreLabel').text('良好');
              }
              $('#goodScoreValue').text(goodScoreCache);
            },
            complete: function() {
              $('#goodScoreValue').text(this.countNum);
              scoreAnimInProgress = 0;

              if (scoreAnimResetRequested === 1) {
                resetScoreAnim();
              }
            }
          });
        }, 3600);
      }
    }

    const resetScoreAnim = () => {
      if (scoreAnimInProgress === 0) {
        stopRuns();
        // wait until scores fade out
        setTimeout(function () {
          $('#poorScoreValue').text('43');
          $('#fairScoreValue').text('55');
          $('#fairScoreLabel').text('標準以下');
          $('#goodScoreValue').text('74');
          $('#goodScoreLabel').text('普通');
        }, 500);
      }
    }

    const awairScoreController = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: awairScoreRef,
      offset: 0,
      duration: '100%'
    })
      .on('enter', () => {
        activeUnhidden();
        scoreAnimResetRequested = 0;
        startScoreAnim();
      })
      .on('leave', () => {
        unactiveUnhidden();
        scoreAnimResetRequested = 1;
        resetScoreAnim();
      })
      .addTo(awairScoreController);
  };

  componentDidMount() {
    this.handleSceneAnimation();
  }

  render() {
    const {poorRun, fairRun, goodRun, unhidden} = awairScoreStore;

    return (
      <section className={cx('awair-score')} ref={ref => this.awairScoreRef = ref}>
        <div className={cx('awair-score-examples')}>
          <ScoreCircle
            run={poorRun}
            circleName='poorCircle'
            ringMaskName='poorRingMask'
            ringShadowName='poorRingShadow'
            ringFillName='poorRingFill'
            targetColor='#FF7B3E'
            initialDigits='43'
            initialLabel='標準以下'
            digitsID='poorScoreValue'
            labelID='poorScoreLabel'
          />
          <ScoreCircle
            run={fairRun}
            circleName='fairCircle'
            ringMaskName='fairRingMask'
            ringShadowName='fairRingShadow'
            ringFillName='fairRingFill'
            targetColor='#FAD243'
            initialDigits='55'
            initialLabel='標準以下'
            digitsID='fairScoreValue'
            labelID='fairScoreLabel'
          />
          <ScoreCircle
            run={goodRun}
            circleName='goodRun'
            ringMaskName='goodRingMask'
            ringShadowName='goodRingShadow'
            ringFillName='goodRingFill'
            targetColor='#B0D632'
            initialDigits='74'
            initialLabel='普通'
            digitsID='goodScoreValue'
            labelID='goodScoreLabel'
          />
        </div>
        <div className={cx('awair-score-description', unhidden && 'unhidden')}>
          <p><span lang='en-thin'>Awair</span>スコアは点数によって色分けされており、空気の質が一目でわかります。<span lang='en-thin'>Awair</span>スコアは100点満点で表示され、100に近づくほど健康的な空気であることを表します。</p>
        </div>
      </section>
    );
  }
}

export default AwairScoreSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/AwairScoreSection/AwairScoreSection.js